import { Component, computed, input, InputSignal, Signal, ChangeDetectionStrategy } from '@angular/core';
import { ProductPricesModel, ProductPriceType } from '@libs/shop/models';
import { ProductPriceAdvantageComponent } from './product-price-advantage';
import { ProductPriceAdvantageFreeComponent } from './product-price-advantage-free';
import { ProductPriceReimbursementComponent } from './product-price-reimbursement';
import { ProductPricesBestComponent } from './product-prices-best';
import { ProductPricesDefaultComponent } from './product-prices-default';
import { ProductPricesDiscountComponent } from './product-prices-discount';

@Component({
  selector: 'ui-product-prices',
  templateUrl: './product-prices.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    ProductPricesDiscountComponent,
    ProductPricesBestComponent,
    ProductPricesDefaultComponent,
    ProductPriceAdvantageFreeComponent,
    ProductPriceAdvantageComponent,
    ProductPriceReimbursementComponent,
  ],
})
export class ProductPricesComponent {
  public productPrice: InputSignal<ProductPricesModel> = input.required();
  public small: InputSignal<boolean> = input(false);
  public showThousandthsPlace: InputSignal<boolean> = input(false);
  public priceType: Signal<ProductPriceType> = computed(() => this.productPrice().priceType);
  public price: Signal<number> = computed(() => this.productPrice().singleUnit);
  public strikethroughPrice: Signal<number> = computed(() => this.productPrice().singleUnitStrikethroughPrice ?? 0);
}
